export function getRootElement() {
  return document.getElementById('root');
}
